export default {
    intro: `看写作素材，写下自己的文章。<br />
            也看看朋友们的文章，给喜欢的文章投票吧。`,
    buttons: { cancel: '取消', submit: '提交' },
    options: {
        timer: { title: '计时器设置', inputTime: '写作时间', voteTime: '投票时间' },
        example: { title: '显示示例答案', description: '在学生画面上显示示例答案。' },
        votesPerStudent: { title: '设置每位学生的投票数' },
    },
    noTitleCard: '这是没有标题的卡片',
    noContentCard: '这是没有内容的卡片',
    exampleAnswer: '示例答案',
    ai: {
        button: 'AI 帮助',
        title: '✨ 写作帮助',
        error: '无法加载 AI 反馈，请稍后再试。',
        submitOk: '👍 就这样提交也很好！',
        strengths: '👍 做得好的地方',
        guideMore: '✏️ 想写得更精彩吗？',
        guideFix: '✏️ 试试这样修改怎么样？',
        exampleLabel: '示例',
    },
    profanityNotice: '因含有不当用语，该卡片已被隐藏。',
    tabs: { check: '1.确认写作素材', write: '2.创建卡片', vote: '3.进行投票', result: '4.投票结果' },
    tabStudent: {
        write: '看写作素材，把你的想法写下来。',
        previousVote: '投票前请先阅读朋友们的文章。',
        vote: '请给你喜欢的文章投票。',
        result: '看看朋友们最喜欢的文章吧！',
    },
    card: { title: '没有写标题 😶', content: '没有写任何内容 😵' },
    cardWritingArea: {
        titlePlaceholder: '请输入标题（30字以内）',
        contentPlaceholder: '请输入内容。',
        unsubmittedStudents: '未提交 {count}人',
    },
    loading: {
        submit: '正在提交你的文章...',
        voteStart: '开始投票',
        voteSubmit: '正在自动提交学生的作文...',
        voteCollect: '正在收集其他学生的作文...',
        voteResult: '正在统计投票',
        readNext: '正在准备下一个写作素材',
    },
    vote: { selfVote: '不能给自己投票', voteLimit: '已用完所有投票。' },
    student: {
        inPlay: {
            readyText: `一边看写作素材，<br />一边想想要写什么吧。`,
            topic: '写作素材',
            foldTopic: '折叠写作素材',
            imageAlt: '图片资料',
            voteRemaining: '还剩{count}票',
            waiting: '等待中',
        },
        toast: {
            contentLengthWarning: '内容请控制在2,000字以内。',
            titleLengthWarning: '标题请控制在30字以内。',
            inputEndWarning: '还剩15秒，写作时间即将结束。',
            voteEndWarning: '还剩15秒，投票即将结束。',
        },
    },
    teacher: {
        setting: {
            titlePlaceholder: '请输入写作素材标题（最多200字）',
            textPlaceholder: '请输入写作素材说明（最多1,000字）',
            inputErrorMessage: '请输入内容',
            delete: '删除',
            register: '保存',
            cancel: '取消',
            addQuestion: '添加写作素材',
        },
        inPlay: {
            readyTextInput: `说明写作素材后<br />
                                    请点击"开始写作"`,
            readyTextSubmit: `学生提交后<br />
                                    将显示在此处。`,
        },
        modal: {
            title: '卡片书写 💬',
            startConfirm: {
                message: '有正在编写的内容用于添加写作素材。',
                subMessage: '如果现在开始活动，编写的内容将全部删除，不会添加为题目。',
                optionalMessage: '仍然要开始活动吗？',
                confirmText: '开始活动',
                cancelText: '继续编写',
            },
            voteStart: {
                message: '还有学生正在写作。',
                subMessage: '要就这样提交卡片并开始投票吗？',
                confirmText: '开始投票',
            },
            voteEnd: {
                message: '投票时间已结束。',
                subMessage: '要查看结果吗？',
                confirmText: '查看结果',
            },
            questionDelete: {
                message: '要删除写作素材吗？',
                subMessage: '删除的写作素材无法恢复。',
                confirmText: '删除',
            },
        },
        button: {
            step: {
                beforeStart: '开始写作',
                writingEnd: '结束写作',
                voteEnd: '结束投票',
                nextTopic: '下一个写作素材',
                activityStart: '开始活动',
            },
        },
        result: { topic: '写作素材' },
    },
};
